import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import EventFactory from "../../Entity/Factories/EventFactory";

export default function* eventForEventDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `events/${action.payload?.eventId}`);

    const event = EventFactory.create(res.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, event);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchEventForEventDetailsPage() {
  yield takeEvery(Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE, eventForEventDetailsPage);
}
